import { useEffect, useState } from "react"
import { updateDoc, Timestamp, doc, deleteDoc } from "firebase/firestore"
import { db } from "../../../Firebase/config"
import Notify from "../Usenotifications"
import axios from "axios"
import { useNavigate } from "react-router-dom"
export const GetonepickuporderHook = (id, document) => {
  const navigate = useNavigate()
  const user = JSON.parse(localStorage.getItem("user"))

  const handleDelete = async (e, orderid) => {
    e.preventDefault()
    await deleteDoc(doc(db, "Orders", orderid))
    Notify("Order deleted", "success")
    setTimeout(() => {
      navigate("/allorders")
    }, 1500)
  }

  return [handleDelete]
}
